import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Stack, Divider } from '@mui/material';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { EntityFileDetails } from 'components/shared/EntityFileDetails';
import { shareList } from 'store/slices/files';
import { formatToString } from 'utils/date-format';
import { useFile } from 'hooks/useFile';
import { Restore } from '@mui/icons-material';

export const DeletedFileDetails = (props) => {
  const { close } = props;

  const dispatch = useDispatch();

  const currentUser = useSelector((state) => state.auth.currentUser);
  const selectedFile = useSelector((state) => state.files.selectedFile);
  const sharedUserList = useSelector((state) => state.files.shareList.value);
  const fileOwner = useMemo(() => {
    if (selectedFile?.ownedBy?.name) {
      return selectedFile?.ownedBy?.name;
    }
    if (selectedFile?.owner === currentUser?.id) {
      return 'Me';
    }
    return '';
  }, [selectedFile, currentUser]);

  const { handleRestoreFile, restoreLoading } = useFile();

  useEffect(() => {
    if (selectedFile?.oid) {
      dispatch(shareList({ fileId: selectedFile.oid }));
    }
  }, [dispatch, selectedFile]);

  return (
    <DrawerContent>
      <DrawerContent.Header
        title={selectedFile?.name}
        loading={restoreLoading}
      />
      <EntityFileDetails>
        {!selectedFile?.id && <EntityFileDetails.EmptyFile />}
        {selectedFile?.id && (
          <>
            <EntityFileDetails.FileType file={selectedFile} />
            {sharedUserList.length > 0 && (
              <>
                <EntityFileDetails.PeopleWithAccess users={sharedUserList} />
                <Divider />
              </>
            )}
            <EntityFileDetails.Details title="Details">
              {selectedFile?.format && (
                <EntityFileDetails.DetailsItem
                  title="Type"
                  subtitle={selectedFile?.format}
                />
              )}
              {fileOwner && (
                <EntityFileDetails.DetailsItem
                  title="Owner"
                  subtitle={fileOwner}
                />
              )}
              {selectedFile?.last_modified && (
                <EntityFileDetails.DetailsItem
                  title="Modified"
                  subtitle={formatToString(selectedFile?.last_modified)}
                />
              )}
              {selectedFile?.createdOn && (
                <EntityFileDetails.DetailsItem
                  title="Created"
                  subtitle={formatToString(selectedFile?.createdOn)}
                />
              )}
            </EntityFileDetails.Details>
            <Divider />
            <Stack
              direction="column"
              spacing={1.5}
            >
              <EntityFileDetails.ActionButton
                title="Restore File"
                icon={<Restore sx={{ fontSize: '22px' }} />}
                action={() => handleRestoreFile(selectedFile, close)}
              />
            </Stack>
          </>
        )}
      </EntityFileDetails>
    </DrawerContent>
  );
};
